import React, { useEffect, useState, useRef, useCallback } from 'react';
import BaseForm, { isView } from '../../../../core/page/components/baseForm/BaseForm';
import Pages from '../../../../config/Pages';
import { Fieldset } from 'primereact/fieldset';
import styles from './IndicadorSolicitacoesForm.module.scss';
import solicitacaoAtivacaoIndicadorService from '../../../../service/SolicitacaoAtivacaoIndicadorService';
import InputField from '../../../../components/inputField/InputField';
import { InputTextarea } from 'primereact/inputtextarea';
import { inputsSolicitacoes } from '../PageInputs';
import { Card } from '@material-ui/core';
import RadioContainer from '../components/radioContainer/RadioContainer';
import DadosSolicitacao from '../components/dadosSolicitacao/DadosSolicitacao';
import { Button } from 'primereact/button';
import Header from '../components/header/Header';
import { useHistory, useParams } from 'react-router-dom';
import { arrayToDateString } from '../../../../core/utils/DateMixins';
import ModalIndicador from '../../indicador/components/modalIndicador/ModalIndicador';
import ConfirmDialog from '../../../../core/components/ConfirmDialog';
import Shareds from '../../../../config/translations/Shareds';

function IndicadorSolicitacoesForm() {
    const history = useHistory();
    const [dados, setDados] = useState(null);
    const { id } = useParams();
    const modalIndicadorRef = useRef(null);
    const formRef = useRef(null);
    const confirmRef = useRef(null);

    const loadData = useCallback(async () => {
        const { dataCadastro, flagAnaliseNegocial, descManifestacaoTecnica, ...response } =
            await solicitacaoAtivacaoIndicadorService.buscarPorId({ id });
        formRef.current?.setInitialValues({
            flagValidacao: flagAnaliseNegocial,
            manifestacao: descManifestacaoTecnica ?? '',
        });
        setDados({ ...response, dataCadastro: arrayToDateString(dataCadastro, true) });
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const Inputs = ({ formik, formController }) => (
        <form onSubmit={formik.handleSubmit}>
            <Fieldset
                className={styles.fieldset}
                legend={
                    <div>
                        Analise Negocial:
                        <span className={styles.required}>*</span>
                    </div>
                }
            >
                <div className={`p-grid p-fluid p-col-12 ${styles.containerInputsRadio}`}>
                    <div
                        className={`p-grid p-fluid p-col-12 ${styles.noPadding} ${
                            formik.errors?.flagValidacao ? styles.borderRed : ''
                        }`}
                    >
                        <div className="p-col-6">
                            <RadioContainer
                                formik={formik}
                                value={true}
                                label="VALIDADO"
                                disabled={
                                    dados?.situacaoSolicitacaoAtivacao
                                        ?.codgSituacaoSolicitacaoAtivacao !== 'PENDENTE' || isView()
                                }
                            />
                        </div>
                        <div className="p-col-6">
                            <RadioContainer
                                formik={formik}
                                value={false}
                                label="NÃO VALIDADO/DESCARTADO ALTERAÇÃO"
                                disabled={
                                    dados?.situacaoSolicitacaoAtivacao
                                        ?.codgSituacaoSolicitacaoAtivacao !== 'PENDENTE' || isView()
                                }
                            />
                        </div>
                    </div>
                    {formik.errors?.flagValidacao && (
                        <small className={`${styles.error} p-col-12`}>
                            {formik.errors?.flagValidacao}
                        </small>
                    )}
                </div>
                <div className="p-grid p-fluid p-col-12">
                    <InputField
                        formik={formik}
                        formController={formController}
                        className={styles.manifestacao}
                        id="manifestacao"
                    >
                        <InputTextarea
                            value={formik.values.manifestacao}
                            onChange={formik.handleChange}
                            disabled={
                                dados?.situacaoSolicitacaoAtivacao
                                    ?.codgSituacaoSolicitacaoAtivacao !== 'PENDENTE' || isView()
                            }
                        />
                    </InputField>
                </div>
            </Fieldset>
            <div className={`buttonsRight ${styles.buttons}`}>
                <Button
                    label="Voltar"
                    type="button"
                    className="p-button-secondary pi pi-arrow-left"
                    onClick={() => {
                        if (formRef.current?.verificaAlteracao()) {
                            confirmRef.current?.show(Shareds.form.dontSaveData, () => {
                                confirmRef.current.hide();
                                setTimeout(() => {
                                    history.push(Pages.sei.indicadorSolicitacoes.url.list);
                                }, 500);
                            });
                        } else {
                            history.push(Pages.sei.indicadorSolicitacoes.url.list);
                        }
                    }}
                />
                {dados?.situacaoSolicitacaoAtivacao?.codgSituacaoSolicitacaoAtivacao ===
                    'PENDENTE' &&
                    !isView() && (
                        <Button
                            label="Salvar"
                            className="pi pi-check"
                            type="submit"
                            onClick={() => formController.addCountClick()}
                        />
                    )}
            </div>
        </form>
    );
    return (
        <>
            <ConfirmDialog ref={confirmRef} />
            <ModalIndicador ref={modalIndicadorRef} />
            <Card className={styles.card}>
                <h5>
                    <strong>{Pages.sei.indicadorSolicitacoes.title}</strong>
                    <small>Analisar</small>
                </h5>
                <Header {...dados} modalIndicadorRef={modalIndicadorRef} />
                <DadosSolicitacao {...dados} />
                <BaseForm
                    ref={formRef}
                    redirectOnSave={false}
                    onSubmit={({ registro }) =>
                        solicitacaoAtivacaoIndicadorService.analisar(id, registro)
                    }
                    actionOnSave={({ success }) => {
                        if (success) {
                            loadData();
                        }
                    }}
                    page={Pages.sei.indicadorSolicitacoes}
                    buscarOnLoad={false}
                    initialValues={inputsSolicitacoes.filter((input) => input?.form?.use ?? false)}
                >
                    <Inputs />
                </BaseForm>
            </Card>
        </>
    );
}

export default IndicadorSolicitacoesForm;
